import {getUserInfo} from "@/api/information";

const state = {
    baseInfo:""
}

const mutations = {
    SET_BASEINFO: (state, info) => {
        state.baseInfo = info
    },
}

const actions = {
    getBaseInfo({ commit}){
          let companyId = sessionStorage.getItem("corporateId");        
          if(null==companyId || "null"==companyId ){        
             return null;
          }else{          
            return new Promise((resolve,reject)=>{
                getUserInfo({id:companyId}).then(res=>{
                    resolve(res.data);
                    commit('SET_BASEINFO',res.data)
                })
              })
          }
    }
}

function  getUrlKey(name){
    return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
            location.href
          ) || [, ''])[1].replace(/\+/g, '%20')
        ) || null
    );
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/company.js